export default {
  'zh': '简体中文',
  'en': 'English',
  'ru': 'Русский язык',
  'vi': 'Tiếng Việt',
  'tr': 'Türkçe',
  'ja': '日本語'
};